import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	weeklyProductionDeployment: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.weekly-production-deployment',
		defaultMessage:
			'Weekly production {deploymentCount, plural, one {deployment} other {deployments}}',
		description:
			'Weekly production deployments. This will be displayed after a number that is weekly production deployment count.',
	},
	weekStartDate: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.selection-detail.week-start-date',
		defaultMessage: 'Week of {date}',
		description: 'Display the start date of the selected week in the bar chart',
	},
});
